var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBenefit1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1h8v3h-2v1.153a12.91 12.91 0 014.145 1.388l2.198-2.198L30 10l-2.309 2.309A12.948 12.948 0 0129 18c0 7.18-5.82 13-13 13S3 25.18 3 18c0-2.041.47-3.972 1.309-5.691L2 10l5.657-5.657 2.198 2.198A12.91 12.91 0 0114 5.153V4h-2V1zm4 27c5.523 0 10-4.477 10-10S21.523 8 16 8 6 12.477 6 18s4.477 10 10 10zm0 1c6.075 0 11-4.925 11-11S22.075 7 16 7 5 11.925 5 18s4.925 11 11 11zm1-16v-3h-2v3h2zm-9 4h3v2H8v-2zm13 0v2h3v-2h-3zm-4 7v3h-2v-3h2zm4-11l-1.65.236-4.007 4.007a1 1 0 001.414 1.414l4.007-4.007L21 13z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
}

export default SvgBenefit1;